/**
 * Shared CSV export helpers.
 *
 * Extracted from PerformanceReviewManagerModal, which had the only working
 * export in the app, so every new export gets the same escaping and the same
 * BOM-prefixed download behaviour rather than a near-copy that drifts.
 */

/** Flatten newlines/tabs so TSV/CSV pastes cleanly into Excel / Sheets. */
export function sanitizeSpreadsheetCell(value) {
  if (value == null) return '';
  return String(value).replace(/[\t\r\n]+/g, ' ').trim();
}

export function escapeCsvField(value) {
  const s = sanitizeSpreadsheetCell(value);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** One CSV line from an array of cells. */
export function csvRow(cells) {
  return cells.map(escapeCsvField).join(',');
}

/**
 * Trigger a client-side download. The leading BOM keeps Excel from mangling
 * non-ASCII names when it opens the file.
 */
export function downloadCsv(filename, csvBody) {
  const blob = new Blob(['\ufeff', csvBody], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
